<template>
  <div class="page-content">
    <page-template
      ref="cdStoreTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog title='门店信息' :visible.sync="dialogShow" @close="closeDialog" width="800px" center
               :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" class="steps-form" :show-message="false" label-width="80px">
        <el-col :span="12">
          <el-form-item label='选择门店' prop="subStoreId">
            <el-select v-model="form.subStoreId" placeholder="请选择" :disabled="isDisabled" @change="selectStore">
              <el-option
                v-for="item in storeList"
                :key="item.value"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label='门店名称' prop="storeName">
            <el-input v-model.trim="form.storeName" placeholder='请输入'></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='营业状态' prop="busy">
            <el-radio-group v-model="form.busy">
              <el-radio :label="false">营业</el-radio>
              <el-radio :label="true">繁忙</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label='联系电话' prop="phone1">
            <el-input type="number" v-model.trim="form.phone1" placeholder='请输入'></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label='门店座机' prop="phone2">
            <el-input type="number" v-model.trim="form.phone2" placeholder='请输入'></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="display: flex;align-items: center">
          <div>
            <span style="color:red">*</span>
            <span style="padding:0 10px 0 2px">门店地址</span>
          </div>
          <el-form-item label='' prop='provinceId' label-width="0">
            <el-select
              @change="provinceChange"
              v-model="form.provinceId"
              filterable
              placeholder="省"
            >
              <el-option v-for="(item,index) in provinceOptions" :key="index" :label="item.name"
                         :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='' prop='cityId' label-width="0">
            <el-select
              @change="cityChange"
              v-model="form.cityId"
              filterable
              placeholder="市"
            >
              <el-option v-for="(item,index) in cityOptions" :key="index" :label="item.name"
                         :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='' prop='districtId' label-width="0">
            <el-select
              @change="areaChange"
              v-model="form.districtId"
              filterable
              placeholder="区"
            >
              <el-option v-for="(item,index) in areaOptions" :key="index" :label="item.name"
                         :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="form.cityId">
          <el-form-item label='详细地址' prop="storeAddress">
            <el-input id="storeAddress" v-model.trim="form.storeAddress" placeholder='请输入' class="inputStyle"
                      @blur="changeKeyword" @keyup.enter.native="searchKeyword">
              <!-- <input id='storeAddress' type="text"><el-button slot="append" icon="el-icon-search" @click="searchKeyword">搜索</el-button>-->
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="form.cityId">
          <el-form-item label='经度' prop="longitude">
            <el-input v-model.trim="form.longitude" placeholder='请输入' disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="form.cityId">
          <el-form-item label='纬度' prop="latitude">
            <el-input v-model.trim="form.latitude" placeholder='请输入' disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="form.cityId">
          <div id="container"></div>
          <!--          <m-map :column="form.map"></m-map>-->
        </el-col>
        <el-col :span="24" style="display: flex;align-items: center">
          <div>
            <span style="color:red">*</span>
            <span style="padding:0 10px 0 2px">营业时间</span>
          </div>
          <el-form-item label='' prop="beginTime" label-width="0">
            <el-time-select
              placeholder="起始时间"
              v-model="form.beginTime"
              :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '24:00',
                }">
            </el-time-select>
          </el-form-item>
          <el-form-item label='' prop="endTime" label-width="0">
            <el-time-select
              placeholder="结束时间"
              v-model="form.endTime"
              :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '24:00',
                  minTime: form.beginTime
                }">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='就餐方式' prop="orderType">
            <el-checkbox-group v-model="form.orderType" :min="1">
              <el-checkbox v-for="(item,index) in orderTypeList" :label="item.id" :key="index">{{item.name}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='支付类型' prop="payType">
            <el-checkbox-group v-model="form.payType" :min="1" @change="changePayType">
              <el-checkbox v-for="(item,index) in payTypeList" :label="item.id" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
            <!--            <el-radio-group v-model="form.payType">-->
            <!--              <el-radio v-for="(item,index) in payTypeList" :label="item.id" :key="index">{{item.name}}</el-radio>-->
            <!--            </el-radio-group>-->
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.payType.includes('2')">
          <el-form-item label='支付方式' prop="onLinePayType">
            <!--            <el-radio-group v-model="form.onLinePayType">-->
            <!--              <el-radio v-for="(item,index) in onLinePayTypeList" :label="item.id" :key="index">{{item.name}}</el-radio>-->
            <!--            </el-radio-group>-->
            <el-checkbox-group v-model="form.onLinePayType" :min="1">
              <el-checkbox v-for="(item,index) in onLinePayTypeList" :label="item.id" :key="index">{{item.name}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='备注' prop="remarks">
            <el-input v-model.trim="form.remarks" placeholder='请输入' class="inputStyle"></el-input>
          </el-form-item>
        </el-col>
        <div class="dialog-footer">
          <el-button type="primary" @click="save">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import mMap from "@/components/controls/mapTemplate";
  import casaderSelect from "@/components/controls/cascaderSelect";
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import qs from 'qs'

  export default {
    components: {
      pageTemplate, casaderSelect, mMap
    },
    data() {
      return {
        isDisabled: false,
        provinceOptions: [],
        cityOptions: [],
        areaOptions: [],
        orderTypeList: [
          {name: '外卖', id: '1'},
          {name: '自取', id: '2'},
          {name: '堂食', id: '3'},
        ],
        payTypeList: [
          {name: '线下支付', id: '1'},
          {name: '在线支付', id: '2'},
        ],
        onLinePayTypeList: [
          {name: '支付宝', id: '1'},
          {name: '微信', id: '2'},
          {name: '银联', id: '6'},
          {name: '钱包', id: '11'},
          {name: '其它', id: '0'},
        ],
        form: {
          subStoreId: '',//门店id
          // storeId:'',
          storeName: '',
          orderType: ['1', '2', '3'],// 就餐方式 1：外卖；2：自取；3：堂食
          payType: ['1', '2'],//支付类型 1：线下付款 2：在线支付
          onLinePayType: ['1', '2', '6', '11', '0'],//支付方式
          provinceId: '',//省份
          cityId: '',//城市
          districtId: '',//区域
          storeAddress: '',//详细地址
          latitude: '',//维度
          longitude: '',//经度
          phoneList: [],//门店号码
          phone1: '',
          phone2: '',
          beginDate: '2020-01-01',//开始日期
          endDate: '2099-12-12',//结束日期
          weeks: '1,2,3,4,5,6,7',//星期
          beginTime: '',//开始时间
          endTime: '',//结束时间
          busy: true,//是否繁忙1：繁忙，0：营业',
          relateType: this.$utils.getSysUser().storeId ? 20 : 10,//10 商户 20门店
          // status:10,//营业状态10，开启，99，关闭
          remarks: '',//备注,
        },
        rules: {
          storeName: [{required: true, trigger: 'change'}],
          latitude: [{required: true, trigger: 'change'}],
          longitude: [{required: true, trigger: 'change'}],
          subStoreId: [{required: true, trigger: 'change'}],
          orderType: [{required: true, trigger: 'change'}],
          // status:[{required:true,trigger:'change'}],
          payType: [{required: true, trigger: 'change'}],
          provinceId: [{required: true, trigger: 'change'}],
          cityId: [{required: true, trigger: 'change'}],
          districtId: [{required: true, trigger: 'change'}],
          storeAddress: [{required: true, trigger: 'change'}],
          beginTime: [{required: true, trigger: 'change'}],
          endTime: [{required: true, trigger: 'change'}],
          phone1: [{required: true, pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}],
          phone2: [{pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}],
          onLinePayType: [{required: true, trigger: 'change'}],
        },
        dialogShow: false,
        // 搜索条件
        searchOptions: {
          simple: [
            // {label: '门店编码', prop: 'code', type: 'input', isFuzzy: true, placeholder: "请输入门店编码"},
            {label: '门店名称', prop: 'otherName', type: 'input', isFuzzy: true, placeholder: "请输入门店名称"}
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.editInfo,
          },
          {
            label: '新增',
            type: this.$utils.buttonType.tableOperate,
            code: 'insert',
            callback: this.addInfo,
          },
          {
            label: '删除',
            type: this.$utils.buttonType.tableOperate,
            code: 'delete',
            filter: (data) => {
              return false
            }
          },
          {
            label: '门店同步',
            type: this.$utils.buttonType.tableOperate,
            code: 'cdStoreSync',
            callback: this.setStoreSync,
            filter: (data) => {
              return data.openSync
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          // showSelect: true,
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店编码',
              prop: 'subStoreId',
              align: 'center',
            },
            {
              label: '映射编码',
              prop: 'storeId',
              align: 'center',
            },
            {label: '门店名称', prop: 'storeName', align: 'center'},
            {
              label: '门店同步状态',
              prop: 'status',
              width: '80',
              align: 'center',
              enumData: this.$utils.getCacheStatus('cdStore.status')
            },
            {
              label: '营业状态',
              prop: 'busy',
              type: 'switch',
              activeValue: true,//繁忙
              inactiveValue: false,//营业
              activeText: '繁忙',
              inactiveText: '营业',
              defaultValue: true,
              align: 'center',
              change: this.openChange,
            },
            {label: '最后操作人', prop: 'lastModifyDesc', width: '120', align: 'center'},
            {
              label: '操作时间',
              prop: 'lastModifyDttm',
              width: '120',
              align: 'center',
            },
          ],
          url: api.takeout.takeoutStore
        },
        // map:null,
        mapZoom: 15,
        centerCode: [108.95, 34.27],
        storeList: [],
        dialogTitle: '',
      };
    },
    created() {
      this.getStoreList()
      this.getRegionList(0, this.provinceOptions)
    },
    mounted() {

    },
    methods: {
      // 选择门店
      selectStore(val) {
        this.storeList.forEach(v => {
          if (v.id === val) {
            this.form.storeName = v.name
          }
        })
      },
      //判断是否可编辑
      getDisabled() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.isDisabled = true
          this.form.subStoreId = userInfo.storeId
        } else {
          this.isDisabled = false
        }
      },
      // 选择省
      provinceChange(value) {
        this.form.cityId = ''
        this.form.districtId = ''
        this.form.storeAddress = ''
        this.getRegionList(value, this.cityOptions, "cityId").then(data => {
          this.provinceOptions.forEach(v => {
            if (v.code == value) {
              this.provinceName = v.name
            }
          })
        })
      },
      // 选择市
      cityChange(value) {
        this.form.districtId = ''
        this.form.storeAddress = ''
        this.form.latitude = ''
        this.form.longitude = ''
        this.getRegionList(value, this.areaOptions, "districtId").then((data) => {
          this.cityOptions.forEach(v => {
            if (v.code == value) {
              this.cityName = v.name
              this.initMap()
              this.mapAutocomplete(this.cityName)
              this.searchDistrict(this.cityName, 'city')
              this.map.setZoom(15)
            }
          })
        })
      },
      // 选择区
      areaChange(value) {
        // this.form.storeAddress = ''
        // if(value && this.areaOptions.length>0){
        //   let targetName = ''
        //   this.areaOptions.forEach(v=>{
        //     if(v.code == value){
        //       if(v.name.indexOf('市辖区')!=-1){
        //         targetName = v.name.slice(0,-3)
        //       }else{
        //         targetName = v.name
        //       }
        //       console.log(targetName)
        //       this.searchDistrict(targetName,'district')
        //       this.initMap(this.cityName)
        //       this.map.setZoom(18)
        //     }
        //   })
        // }
      },
      // 获取地区集合
      getRegionList(parentId, options, areaUnit = "") {
        return new Promise((reslove, reject) => {
          options.length = 0;
          let url = api.takeout.cdAreaList;
          let param = {parentId: parentId}
          this.$axios.fetchPost(url, qs.stringify(param), {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}).then((res) => {
            if (res.code === 200) {
              if (res.data) {
                res.data.forEach(v => {
                  options.push(v)
                })
              }
            } else {
              this.$message.error("地区集合获取失败！" + res.errorMsg);
            }
            reslove(options)
          });
        })
      },
      // 获取门店
      getStoreList() {
        this.$axios.fetchPost(api.store.store + '/list', {}).then(res => {
          if (res.code == 200) {
            res.data.unshift({name: '总部', id: -1})
            this.storeList = res.data
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 设置营业状态
      openChange(row) {
        let loading = this.$loading({
          lock: true,
          text: '门店同步中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)',
        });
        this.$axios.fetchPost(api.takeout.cdStatus, row).then(res => {
          if (res.code == 200) {
            setTimeout(() => {
              this.$notify({
                type: "success",
                title: '营业状态修改操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({type: 'success', message: '营业状态修改成功'});
            }, 3000)
          } else {
            this.$message({type: 'error', message: res.errorMsg});
          }
        }).catch(err => {
          this.$notify({
            type: "error",
            title: '营业状态修改操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({type: 'error', message: '操作失败!'});
        }).finally(() => {
          setTimeout(() => {
            this.$refs.cdStoreTemplate.operationSuccess()
            loading.close()
          }, 3000)
        })
      },
      // 选择营业时间
      timeChange(val) {
        console.log(val)
      },
      //根据详细地址 搜索地图
      changeKeyword() {
        // this.placeSearchComponent.search(this.form.storeAddress, (status, result)=> {
        //   // 查询成功时，result即对应匹配的POI信息
        //   console.log(status);
        //   console.log(result);
        //   if(status != 'complete'){
        //     this.form.storeAddress = ''
        //     this.$message.warning('请输入或选取地图上有效的地址信息')
        //   }
        // })
      },
      searchKeyword(event) {
        event.target.blur()
      },
      mapAutocomplete(city) {
        this.marker = new AMap.Marker();
        //输入提示
        AMap.plugin('AMap.Autocomplete', () => {
          // 实例化Autocomplete
          var autoOptions = {
            //city 限定城市，默认全国
            city: city,
            input: 'storeAddress',
          }
          let autoCompleteComponent = new AMap.Autocomplete(autoOptions)
          // 根据自动搜索 选择地址
          AMap.event.addListener(autoCompleteComponent, "select", (data) => {
            console.log(data)
            if (data.poi.location != undefined) {
              this.form.latitude = data.poi.location.lat
              this.form.longitude = data.poi.location.lng
              this.form.storeAddress = data.poi.district + data.poi.name
              //定位到中心点
              this.map.setCenter(data.poi.location);
              this.map.add(this.marker);
              this.marker.setPosition(data.poi.location);
            }
          })
          this.placeSearchComponent = autoCompleteComponent;
        })
      },
      // 地图初始化
      initMap() {
        // var map = new AMap.Map('container');
        this.map = new AMap.Map('container', {
          zoom: this.mapZoom,//级别
          center: this.centerCode,//中心点坐标
        })
        // 创建一个 门店Icon
        // this.storeIcon = new AMap.Icon({
        //   size: new AMap.Size(30, 30),
        //   image: require('../../../static/home.png'),
        // });
        this.marker = new AMap.Marker();
        // 地图点击事件
        this.map.on('click', (e) => {
          //逆地理编码（坐标 -> 地址
          this.form.latitude = e.lnglat.lat
          this.form.longitude = e.lnglat.lng

          let geocoder = new AMap.Geocoder({
            city: "全国", //城市设为北京，默认：“全国”
            radius: 1000 //范围，默认：500
          });
          geocoder.getAddress(e.lnglat, (status, result) => {
            console.log(result)
            if (status === 'complete' && result.regeocode) {
              // 地图 marker 标记
              this.map.add(this.marker);
              this.marker.setPosition(e.lnglat);
              this.form.storeAddress = result.regeocode.formattedAddress;
            } else {
              this.$message.error('根据经纬度查询地址失败')
            }
          });
        });
        // this.searchDistrict('陕西省','province')

      },
      // 行政区域查询
      searchDistrict(districtName, level, center) {
        let district = null;
        let polygons = [];
        //加载行政区划插件
        if (!district) {
          var opts = {
            subdistrict: 0,   //获取边界不需要返回下级行政区
            extensions: 'all',  //返回行政区边界坐标组等具体信息
            level: level  //查询行政级别为 district 区县
          };
          district = new AMap.DistrictSearch(opts);
        }
        //行政区查询
        district.search(districtName, (status, result) => {
          console.log(status)
          if (status === 'complete') {
            this.centerCode = [result.districtList[0].center.lng, result.districtList[0].center.lat]//城市中心
            var outer = [
              new AMap.LngLat(-360, 90, true),
              new AMap.LngLat(-360, -90, true),
              new AMap.LngLat(360, -90, true),
              new AMap.LngLat(360, 90, true)
            ]
            var holes = result.districtList[0].boundaries
            var pathArray = [outer]
            pathArray.push.apply(pathArray, holes)
            this.polygon = new AMap.Polygon({
              pathL: pathArray,
              strokeColor: '#0091ea',//城市边界颜色
              strokeWeight: 2,
              fillColor: '#ffffff', // 遮罩背景色黑色
              fillOpacity: 1
            })
            this.polygon.setPath(pathArray)
            this.map.add(this.polygon)
            if (center) {
              this.map.setCenter(center)
            } else {
              this.map.setCenter(this.centerCode)
            }

          } else {
            return false
          }
        });
      },
      //新增门店
      addInfo() {
        this.dialogTitle = '新增'
        this.dialogShow = true
        this.getDisabled()
        setTimeout(() => {
          this.initMap()
        }, 500)
      },
      // 编辑
      editInfo(row) {
        this.dialogTitle = '编辑'
        this.dialogShow = true
        this.isDisabled = true
        this.$axios.fetchGet(api.takeout.takeoutStore + '?id=' + row.id).then(res => {
          if (res.code == 200) {
            this.form = res.data
            // 电话
            if (res.data.phoneList && res.data.phoneList.indexOf(',') != -1) {
              if (res.data.phoneList.split(',').length > 0) {
                this.form.phone1 = res.data.phoneList.split(',')[0]
              }
              if (res.data.phoneList.split(',').length > 1) {
                this.form.phone2 = res.data.phoneList.split(',')[1]
              }
            }
            // 就餐方式
            this.form.orderType = res.data.orderType.split(',')
            // 支付类型
            this.form.payType = res.data.payType.split(',')
            // 在线支付方式
            this.form.onLinePayType = res.data.onLinePayType.split(',')
            // 市区 回显
            // this.provinceName = this.provinceOptions.filter(v=>v.code == res.data.provinceId)[0].name
            this.getRegionList(res.data.cityId, this.areaOptions, "districtId");
            this.getRegionList(res.data.provinceId, this.cityOptions, "cityId").then(() => {
              let city = this.cityOptions.filter(v => v.code == res.data.cityId)[0]
              // this.areaName = this.areaOptions.filter(v=>v.code == res.data.districtId)[0].name
              // this.cityName = city.name
              //定位到中心点
              this.centerCode = [Number(this.form.longitude), Number(this.form.latitude)]
              this.initMap()
              this.searchDistrict(city.name, 'city', this.centerCode)
              this.mapAutocomplete(city.name)
              this.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: this.centerCode
              });
              this.marker.setMap(this.map);
              this.map.setCenter(this.centerCode)
            })
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 同步门店
      setStoreSync(row) {
        this.$confirm('同步门店？确认')
          .then(_ => {
            let loading = this.$loading({
              lock: true,
              text: '门店同步中，请稍候...',
              background: 'rgba(225, 225, 225, 0.8)',
            });
            this.$axios.fetchPost(api.takeout.cdStoreSync, row).then(res => {
              if (res.code == 200) {
                setTimeout(() => {
                  this.$refs.cdStoreTemplate.operationSuccess()
                  this.$notify({
                    type: "success",
                    title: '同步操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message({type: 'success', message: '同步成功'});
                }, 3000)
              } else {
                this.$message({type: 'error', message: res.errorMsg + ',同步失败'});
              }
            }).catch(err => {
              this.$notify({
                type: "error",
                title: '同步操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({type: 'error', message: '同步失败!'});
            })
              .finally(() => {
                setTimeout(() => {
                  loading.close()
                }, 3000)
              })
          })
          .catch(_ => {
          })
      },
      // 选择支付类型
      changePayType(val) {
        console.log(val)
        if (val.includes('2')) {
          this.form.onLinePayType = ['1', '2', '6', '11', '0']
        }
      },
      // 保存
      save() {
        // if(!this.form.latitude || !this.form.longitude){
        //   this.$message.warning('请选取地图上有效的地址信息,以获得经纬度')
        //   this.form.storeAddress = ''
        // }else
        //   if(this.form.payType == '2' && !this.form.onLinePayType){
        //   this.$message.warning('请选择在线支付方式')
        // }else{
        this.$refs.form.validate(valid => {
          let params = this.$utils.deepClone(this.form);
          if (valid) {
            params.phoneList = ''
            params.phoneList = params.phone1 + ',' + params.phone2
            params.phone1 = null
            params.phone2 = null
            // 支付类型
            let payType = ''
            if (params.payType.length > 0) {
              params.payType.forEach(v => {
                if (v) {
                  payType += v + ','
                }
              })
            }
            // 在线支付方式
            let onLinePayType = ''
            if (params.onLinePayType.length > 0) {
              params.onLinePayType.forEach(v => {
                if (v) {
                  onLinePayType += v + ','
                }
              })
            }
            // 就餐方式
            let orderType = ''
            if (params.orderType.length > 0) {
              params.orderType.forEach(v => {
                if (v) {
                  orderType += v + ','
                }
              })
            }
            if (payType.indexOf('2') == -1) {
              onLinePayType = ''
            }
            params.orderType = orderType
            params.payType = payType
            params.onLinePayType = onLinePayType
            params.openSync = 1
            // if(params.storeAddress.indexOf('省')==-1){
            //   params.storeAddress = this.provinceName + params.storeAddress
            // }
            // if(params.storeAddress.indexOf('市')==-1){
            //   params.storeAddress = this.cityName + params.storeAddress
            // }
            console.log(params)
            if (this.dialogTitle === '新增') {
              this.$loading({text: '提交中，请稍后。。。'})
              this.$axios.fetchPost(api.takeout.takeoutStore, params).then(res => {
                if (res.code == 200) {
                  this.$refs.cdStoreTemplate.operationSuccess()
                  this.$notify({
                    type: "success",
                    title: '新增操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message({type: 'success', message: '新增成功'});
                  this.closeDialog()
                } else {
                  this.$message({type: 'error', message: res.msg});
                }
              }).catch(err => {
                this.$notify({
                  type: "error",
                  title: '新增操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({type: 'error', message: '保存失败!'});
              }).finally(() => {
                this.$loading({}).close()
              })
            } else {
              this.$loading({text: '提交中，请稍后。。。'})
              this.$axios.fetchPut(api.takeout.takeoutStore, params).then(res => {
                if (res.code == 200) {
                  this.$refs.cdStoreTemplate.operationSuccess()
                  this.$notify({
                    type: "success",
                    title: '编辑操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message({type: 'success', message: '编辑成功'});
                  this.closeDialog()
                } else {
                  this.$message({type: 'error', message: res.msg});
                }
              }).catch(err => {
                this.$notify({
                  type: "error",
                  title: '编辑操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({type: 'error', message: '保存失败!'});
              }).finally(() => {
                this.$loading({}).close()
              })
            }
          } else {
            return false
          }
        })
        // }
      },
      // 关闭弹框
      closeDialog() {
        this.dialogShow = false
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
        this.form = {
          subStoreId: '',
          // storeId:'',
          storeName: '',
          orderType: ['1', '2', '3'],// 就餐方式 1：外卖；2：自取；3：堂食
          payType: ['1', '2'],//支付类型 1：线下付款 2：在线支付
          onLinePayType: ['1', '2', '6', '11', '0'],//支付方式
          provinceId: '',//省份
          cityId: '',//城市
          districtId: '',//区域
          storeAddress: '',//详细地址
          latitude: '',//维度
          longitude: '',//经度
          phoneList: [],//门店号码
          phone1: '',
          phone2: '',
          beginDate: '2020-01-01',//开始日期
          endDate: '2099-12-12',//结束日期
          weeks: '1,2,3,4,5,6,7',//星期
          beginTime: '',//开始时间
          endTime: '',//结束时间
          busy: true,//是否繁忙1：繁忙，0：营业',
          relateType: this.$utils.getSysUser().storeId ? 20 : 10,//10 商户 20门店
          // status:10,//营业状态10，开启，99，关闭
          remarks: '',//备注,
        }
      },
    }
  };
</script>

<style scoped>
  .steps-form >>> .el-form-item {
    min-height: 35px;
  }

  /*时间选择器加宽*/
  .steps-form >>> .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 300px;
    padding: 0 3px;
  }

  /*至 加宽*/
  .steps-form >>> .el-date-editor .el-range-separator {
    padding: 0;
    line-height: unset;
  }

  .steps-form >>> .el-date-editor .el-range__icon {
    line-height: 30px;
  }

  /*详细地址 备注*/
  .inputStyle {
    width: 70%;
  }

  .steps-form >>> .el-checkbox-group {
    height: 30px;
  }

  #container {
    width: 80%;
    height: 300px;
    margin: 10px 0;
  }

  >>> .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 10px);
    /*max-width: calc(100% - 30px);*/
    display: flex;
    flex-direction: column;
  }

  >>> .el-dialog__body {
    overflow: auto;
    padding: 0 50px;
  }

  >>> .el-dialog__header {
    margin-bottom: 10px !important;
  }

  .dialog-footer button {
    margin: 10px 0;
  }

</style>
<style>
  /*地图自动搜索框 层级*/
  .amap-sug-result {
    z-index: 999999 !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/takeOut/Store.vue